import { Box, CircularProgress, Grid, Stack, Typography } from "@mui/joy"

function LoadingTag(props) {
    return <Box
        sx={{
            textAlign: "center",
            display: "flex",
            maxWidth: "210px",
            // border: "1px solid black",
            padding: "5px 0px",
            justifyContent: "center",
            alignItems: "center"

        }}>
        <Stack direction={"row"} spacing={2} sx={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center"
        }}>
            <CircularProgress color="danger" size={"sm"} />
            <Box sx={{paddingTop: "5px"}}>
                <Typography>{typeof(props.text) !== "undefined" ? props.text : "Carregando dados..."} </Typography>
            </Box>
        </Stack>
    </Box>
}

export default LoadingTag